module.exports = __webpack_public_path__ + "static/media/upload.bd44d4f4.svg";